export enum SituacaoCaptado {
  CAPTADO = 'CAPTADO',
  REJEITADO = 'REJEITADO',
  APROVADO = 'APROVADO',
}
